import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { DialogBody, Heading } from '@zillow/constellation';

import Modals from 'app/shared/components/Modal';
import ModalActions from 'app/shared/actions/ModalActions';
import ModalSelectors from 'app/shared/selectors/ModalSelectors';

import { StyledModalDialog } from './StyledComponents';

const ModalContainer = () => {
    const dispatch = useDispatch();
    const {
        footer,
        header,
        isFluid,
        modalType,
        onClose,
        onOpen,
        shouldCloseOnOverlayClick,
        isOpen,
        ...modalProps
    } = useSelector(state => ModalSelectors.makeModal(state));
    const ModalContent = Modals[modalType];

    useEffect(() => {
        if (onOpen) {
            onOpen();
        }
    }, [modalType]);

    const handleClose = () => {
        if (onClose) {
            onClose();
        }

        dispatch(ModalActions.hideModal());
    };

    return (
        <StyledModalDialog
            header={<Heading level={6}>{header}</Heading>}
            footer={footer && <div>{footer()}</div>}
            mediaQuery={{ xs: { fullScreen: true }, lg: { fullScreen: false } }}
            isFluid={isFluid}
            isOpen={isOpen}
            onClose={handleClose}
            scrollDocument={false}
            shouldCloseOnOutsideClick={shouldCloseOnOverlayClick}
            wide={true}
        >
            <DialogBody>
                {ModalContent && <ModalContent {...modalProps} dispatch={dispatch} />}
            </DialogBody>
        </StyledModalDialog>
    );
};

export default withRouter(ModalContainer);
